import React from "react";
import PropTypes from "prop-types";

import { useSubscriptionSelectorManager } from "../../hooks";
import { Button, Grid, PlanCard, PlanCardPlaceholder } from "./components";

function SelectSubscriptionStep({
  currentPlanKey,
  initialPlanId,
  loading,
  plans,
  error,
  onSelect,
  onReloadPlanData,
}) {
  const {
    selectedPlan,
    setSelectedPlan,
    onSuggestedHintClicked,
    showPlanReloadButton,
  } = useSubscriptionSelectorManager(initialPlanId, plans, onReloadPlanData);

  if (loading) return <PlanCardPlaceholder />;

  if (error)
    return (
      <div data-test="plan-query-error" style={{ color: "red" }}>
        {error}
      </div>
    );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1em" }}>
      {plans.length > 0 && (
        <Grid data-test="select-subscription-step" columns={plans.length}>
          {plans.map(({ id, ...planProps }) => {
            return (
              <Grid.Column key={id}>
                <PlanCard
                  id={id}
                  onClick={(planId) => {
                    const selected = planId === currentPlanKey ? null : planId;
                    setSelectedPlan(selected);
                    onSelect(selected);
                  }}
                  selected={selectedPlan === id}
                  isCurrent={currentPlanKey === id}
                  onSuggestedHintClicked={onSuggestedHintClicked}
                  reloadButton={
                    showPlanReloadButton && (
                      <Button
                        positive
                        compact
                        content="Check Again If I Am Eligible"
                        onClick={onReloadPlanData}
                      />
                    )
                  }
                  {...planProps}
                />
              </Grid.Column>
            );
          })}
        </Grid>
      )}
    </div>
  );
}

SelectSubscriptionStep.propTypes = {
  loading: PropTypes.bool,
  currentPlanKey: PropTypes.string,
  plans: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  error: PropTypes.string,
  initialPlanId: PropTypes.string,
  onReloadPlanData: PropTypes.func.isRequired,
};

SelectSubscriptionStep.defaultProps = {
  currentPlanKey: null,
  plans: [],
  loading: false,
  error: null,
  initialPlanId: null,
};

export default SelectSubscriptionStep;
